<template>
    <div class="main-app">
        <navbar></navbar>
        <!-- Page content -->
        <div class="page-content bg-white">
            <sidebar></sidebar>
            <router-view></router-view>
        </div>
        <!-- /page content -->
    </div>
</template>
<script>

//elements
import navbar from '@components/pages/elements/navbar/Index.vue'
import sidebar from '@components/pages/elements/sidebar/Index.vue'
import Application from "../../../plugins/limitless";
import FixedSidebarCustomScroll from "../../../plugins/custom";

export default {
    data() {
        return {

        }
    },
    components:{
        navbar, sidebar
    },
    mounted: function () {
        Application.initCore();
        FixedSidebarCustomScroll.init();
    },
    watch: {
        user (newValue, oldValue) {
            if (newValue == null) this.$router.push('/auth/login');
        }
    },
    computed: {

    },
}
</script>